/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.27.0
 */

import { IMegaPower } from '@/main/pages/PageSubscriberId/components/Info/types';
import { IMegaPowersUpdateParams } from '@/main/pages/WizardProductOfferings/wizardProductOfferingsTypes';

export const mapMegaPowersToActivatedAndDeactivated = (
    initialMegaPowers: IMegaPower[],
    changedMegaPowers: IMegaPower[],
): IMegaPowersUpdateParams => {
    const result: IMegaPowersUpdateParams = {};

    const toActivate: Array<{ id: IMegaPower['id'] }> = [];
    const toDeactivate: Array<{ id: IMegaPower['id'] }> = [];

    initialMegaPowers.forEach((initialPower) => {
        const changedPower = changedMegaPowers.find((power) => power.id === initialPower.id);

        if (changedPower && changedPower.connected !== initialPower.connected) {
            if (changedPower.connected) {
                toActivate.push({ id: initialPower.id });
            } else {
                toDeactivate.push({ id: initialPower.id });
            }
        }
    });

    if (toActivate.length) {
        result.toActivate = toActivate;
    }

    if (toDeactivate.length) {
        result.toDeactivate = toDeactivate;
    }

    if (!toActivate.length && !toDeactivate.length) {
        result.toActivate = toActivate;
        result.toDeactivate = toDeactivate;
    }

    return result;
};
